
import createIconComponent from '../utils/createIconComponent';
import { SVG_BANK_ACCOUNT_OUTLINED } from '../../../dist';
import React from 'react';
const BankAccountOutlinedIcon = createIconComponent({ content: SVG_BANK_ACCOUNT_OUTLINED, height: 24, width: 24 });
BankAccountOutlinedIcon.displayName = 'BankAccountOutlinedIcon';
export default BankAccountOutlinedIcon;
